module.exports = __webpack_public_path__ + "img/0Q3A6952_P_L_Foamcore_MockedUp.847564ef.jpg";